// libraries
import React from 'react';
import { checkMobile } from "../../Styles/ScreenCalcs";
import { Helmet } from 'react-helmet';

import HeaderBar from '../../Components/HeaderBar';
import { projectDetailData } from './ProjectDetailPageComponents/ProjectDetailData';
import ProjectDetailListComponent from './ProjectDetailPageComponents/ProjectDetailListComponent';
import ScreenWithCaptionList from './ProjectDetailPageComponents/ScreenWithCaptionComponent';
import ProjectAnnouncementComponent from './ProjectDetailPageComponents/ProjectAnnouncementComponent';
import { ZoomableImg } from './ProjectDetailPageComponents/ZoomableImage';

import ImageScrollList from './ProjectDetailPageComponents/ImageScrollList';

import ScrollButton from '../../Components/ScrollButton';

// assets
import banner from '../../assets/netxd/netxd_banner.png';

import netxd_persona1 from '../../assets/netxd/netxd persona 1.png';
import netxd_persona2 from '../../assets/netxd/netxd persona 2.png';
import netxd_sketch from '../../assets/netxd/netxd_sketch.png';
import netxd_initial_flow from '../../assets/netxd/netxd initial flow.mov';
import click_agent_flow from '../../assets/netxd/click agent flow.mov';
import netxd_samples from '../../assets/netxd/samples.png';
import netxd_onboarding from '../../assets/netxd/netxd onboarding.mov';
import agent_creation from '../../assets/netxd/agent creation.png';
import agent_editing from '../../assets/netxd/agent editing.png';
import agent_running from '../../assets/netxd/agent running.png';
import use_agents_tab from '../../assets/netxd/use agents tab.mov';
import data_privacy from '../../assets/netxd/data privacy.png';
import directory_overview from '../../assets/netxd/directory overview.png';
import search_overview from '../../assets/netxd/search overview.png';
import agent_big_cut from '../../assets/netxd/agent big cut.mov';

// css
import './ProjectDetailPageComponents/ProjectDetailPage.css';
import './Unmasked.css'
import { Link } from 'react-router-dom';
import Footer from './ProjectDetailPageComponents/Footer';
import PasswordComponent from '../../Components/PasswordComponent';

class NETXDProjectPage extends React.Component {
  constructor(props) {
    super(props)
    this.data = projectDetailData;
    this.background = banner;
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.accent_color = '#F05A37' // Orange color for NETXD
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  renderTags(tags) {
    let tag = tags.map((t, index) => {
      return (
        <div className='project-detail-tag-box font-medium-small' style={{backgroundColor:this.accent_color}}>
          <Link to={"/work?tag=" + t} style={{color:'#FFFFFF', textDecoration:'none'}}>{t}</Link>
        </div>
      )
    });
    return tag;
  }

  updateWindowDimensions() {
    this.setState({ width: document.documentElement.clientWidth, height: window.innerHeight });
  }

  getBackgroundSize() {
    if(this.state.width < 720) {
      return 'contain'
    }
    return '100vw'
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <ScrollButton />
        <HeaderBar colorset="dark" />
        <div className={'project-detail-page-banner'} style={{backgroundImage: `url(${this.background})`, backgroundPosition: 'top', backgroundRepeat: 'no-repeat'}} />
        <div className='project-detail-page-layout'>
          {/* ---------- Title ---------- */}
          <h1 className="h1">NETXD <span style={{opacity: '90%', fontWeight: 400}}>- Enterprise AI</span></h1>
          <h2 className="h2">
          <a target="_blank" href="https://netxd.com/#/ai" style={{color: this.accent_color}}>NETXD</a> offers enterprise solutions for AI-powered automation in banking, fintech, and back-office operations. As the sole designer for the company, I was tasked with conceptualizing and designing their first Enterprise AI document review platform: XDAI.
          </h2>

          {/* ---------- Tags ---------- */}
          <div className='project-detail-tag-layout'>
            {this.renderTags(["Featured", "UI/UX", "Graphic Design"])}
          </div>

          <PasswordComponent
            sha256={'fc97013f69b1cbc4d4b26220fb8903991343024fd159fc6013974eda2a09d2c5'}
            color={this.accent_color}>

          {/* ---------- README ---------- */}
          <div style={{
            backgroundColor: 'rgba(240, 90, 55, 0.1)',
            padding: '30px',
            borderRadius: '15px',
            marginTop: '20px',
            marginBottom: '20px'
          }}>
            <p className='p'>
              <b>READ ME</b> <br/>
              Please excuse the lack of completeness here! I've put together a very quick overview of my ongoing work for NETXD's Enterprise AI tool. If you'd like to peruse a selection of my work from this project, you can find the Figma <a href="https://www.figma.com/design/2QH8XceW5q8wKV8M2yUsd3/NETXD-Project-Overview?node-id=1-16775&t=Q5Yzlf91Ky1NgGYh-1" target="_blank" style={{color: this.accent_color}}>here</a> (same password as this page). 
              <br/><br/>
              Feel free to contact me at <a href="mailto:mira.ram@gmail.com" style={{color: this.accent_color}}>mira.ram@gmail.com</a> with any clarifying questions 🙂
            </p>
          </div>

          {/* ---------- Summary ----------
          <h2 className='h2'>Summary</h2>
          <p className='p'>
          NETXD offers enterprise solutions for AI-powered automation in banking, fintech, and back-office operations. As the sole designer for the company, I was tasked with conceptualizing and designing their first Enterprise AI document review platform: XDAI.      </p> */}

          {/* ---------- Splash GIF / Video ---------- */}
          <video autoPlay loop muted playsInline width="100%" height="auto" style={{borderRadius:35}}>
            <source src={agent_big_cut} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          

          {/* ---------- Deliverables and Impact ---------- */}
          <br/><br/>
          <div className='callout-container' style={{ display: 'flex', gap: '20px', flexWrap: 'wrap',marginBottom:'-15px' }}>
            <div className='callout' style={{ flex: '1', minWidth: '300px' }}>
              <h2 className='h2' style={{ marginBottom: '20px' }}>Deliverables</h2>
              <p className='p' style={{ fontWeight: '400' }}>
                The initial workflows of an enterprise document review platform including:
              </p>
              <ul className='ul'>
                <li className='li' style={{ fontWeight: '400' }}>
                  Clickable prototypes
                </li>
                <li className='li' style={{ fontWeight: '400' }}>
                  User flows
                </li>
                <li className='li' style={{ fontWeight: '400' }}>
                  Product specs for development
                </li>
                <li className='li' style={{ fontWeight: '400' }}>
                  Design system and style guide
                </li>
              </ul>
            </div>

            <div className='callout' style={{ flex: '1', minWidth: '300px' }}>
              <h2 className='h2' style={{ marginBottom: '20px' }}>Impact</h2>
              <ul className='ul'>
                <li className='li' style={{ fontWeight: '400' }}>
                  <b style={{ color: this.accent_color }}>Secured investor funding</b> with initial prototype
                </li>
                <li className='li' style={{ fontWeight: '400' }}>
                  <b style={{ color: this.accent_color }}>Shipped the first version</b> of the product
                </li>
                <li className='li' style={{ fontWeight: '400' }}>
                  Secured contracts with <b style={{ color: this.accent_color }}>Fortune 500</b> companies
                </li>
              </ul>
            </div>
          </div>

          {/* ---------- Project Details ----------*/}
          <ProjectDetailListComponent
            color={this.accent_color}
            titles={["Time frame", "Skills", "Tools", "Team"]}
            textFields={["2025 (3 months)",
                         "Prototyping\nCompetitive Research\nDesign System\nBranding\nEnterprise UX Design\nRapid Iteration",
                         "Figma\nMiro",
                         "Mira Ram (Lead Designer)\nGeno Moscetti (Product Manager)\nEngineering Team"]}
          />

          {/* ---------- Problem ----------*/}
          <h2 className='h2'>Problem</h2>
          <h3 className='h3'>User Needs</h3>
          <p className='p'>
          With existing NETXD products already serving enterprise users (e.g., banking and AskBuddy), we identified key pain points:
          </p>
          <ul className='ul'>
            <li className='li' style={{ fontWeight: '400' }}>
              Users manage hundreds of documents weekly—contracts, invoices, onboarding materials, compliance checklists.
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              The review process is slow, manual, error-prone, and fragmented across tools.
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              Users need a way to efficiently extract insights and trigger workflows without switching contexts.
            </li>
          </ul>

          <p className='p'>
          <ImageScrollList>
            <img src={netxd_persona1} alt="NETXD User Persona 1" />
            <img src={netxd_persona2} alt="NETXD User Persona 2" />
          </ImageScrollList>
          </p>

          {/* ---------- THE PROBLEM ---------- */}
          <ProjectAnnouncementComponent
            color = {this.accent_color}
            title = "DESIGN CHALLENGE"
            text = {`How might we streamline the document review process for an organization?`}
          />

          <h3 className='h3'>Business goals</h3>
          <p className='p'>
          NETXD aimed to apply its proprietary Large Action Model (LAM) to power a secure, intelligent review platform for enterprise users.
          <br/><br/>
          The product needed to:
          </p>
          <ul className='ul'>
            <li className='li' style={{ fontWeight: '400' }}>
              Reduce manual review time
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              Fit into familiar workflows
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              Provide actionable insights with minimal effort
            </li>
          </ul>

          

          <div className="divider"></div>

          {/* ---------- Approach ---------- */}
          <h2 className='h2'>Approach</h2>
          
          <h3 className='h3'>Competitive research</h3>
          <p className='p'>
          I conducted a landscape review of existing AI and enterprise tools. Common problems included:
          <br/><br/>
          <b>Not tailored for enterprise:</b>
          </p>
          <ul className='ul'>
            <li className='li' style={{ fontWeight: '400' }}>
              Doesn't integrate with internal systems
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              Chat interfaces are often too generic and limited for complex tasks
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              Can't reliably create shortcuts for common actions
            </li>
          </ul>

          <p className='p'>
          <b>Hard to adopt:</b>
          </p>
          <ul className='ul'>
            <li className='li' style={{ fontWeight: '400' }}>
              Non-technical users don't understand the potential value
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              Security concerns with AI tools accessing proprietary data
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              Difficult to try out a real workflow before committing a whole organization to a new tool
            </li>
          </ul>

          <ProjectAnnouncementComponent
            color = {this.accent_color}
            title = "CHALLENGE"
            text = {`How might we build an AI tool for the average enterprise employee?`}
          />

          <h3 className='h3'>Principles</h3>
          <p className='p'>
          Based on the user needs, business needs, and research, I established three core design principles to guide the development of XDAI - NETXD's Enterprise AI document review platform:
          </p>

          <ol className='ul'>
            <li className='li' style={{ fontWeight: '400' }}>
              <b style={{ color: this.accent_color }}>Familiar</b> - To make XDAI feel as intuitive as using AI and document review tools users already know and trust
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              <b style={{ color: this.accent_color }}>Straightforward</b> - To ensure users immediately understand what XDAI can do and how to apply it to their own workflows 
            </li>
            <li className='li' style={{ fontWeight: '400' }}>
              <b style={{ color: this.accent_color }}>Adaptable</b> - To support a wide range of workflows by letting users tailor the tool to how they already work
            </li>
          </ol>

          <div className="divider"></div>

          {/* ---------- Solutions ---------- */}
          <h2 className='h2'>Solutions</h2>


        {/* --------- SOLUTIONS 1 --------- */}
          <h3 className='h3'>1 - Iterating on <b style={{ color: this.accent_color }}>Familiar</b> Patterns</h3>
          <p className='p'>
          XDAI's early iterations drew inspiration from tools like ChatGPT, Claude, and NotebookLM. I focused on maintaining well-established UX patterns while customizing them for enterprise needs.
          </p>

          <div style={{maxHeight:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
            <ZoomableImg key={netxd_sketch} src={netxd_sketch} />
          </div>
          <p className='p' style={{textAlign: 'center', fontSize: '14px', opacity: '80%', marginTop: '10px'}}>
            Initial sketches for XDAI
          </p>

          <br/><br/>

          <video autoPlay loop muted playsInline width="100%" height="auto" style={{borderRadius:35}}>
            <source src={netxd_initial_flow} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <p className='p' style={{textAlign: 'center', fontSize: '14px', opacity: '80%', marginTop: '10px'}}>
            First prototyped iteration of the chat flow
          </p>

          <br/><br/><br/>

          {/* --------- SOLUTIONS 2 --------- */}

          <h3 className='h3'>2 - Creating a <b style={{ color: this.accent_color }}>Straightforward</b> Experience</h3>
          
          <p className='p'>
            <b>Clear onboarding</b><br/>
            Users are guided through an example flow so they can see how XDAI fits into their daily tasks.
          </p>

          <video autoPlay loop muted playsInline width="100%" height="auto" style={{borderRadius:35}}>
            <source src={netxd_onboarding} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p className='p' style={{textAlign: 'center', fontSize: '14px', opacity: '80%', marginTop: '10px'}}>
            First prototyped iteration of the onboarding experience
          </p>
          <br/><br/>

          <p className='p'>
            <b>Targeted examples</b><br/>
            After a user finishes the onboarding and opens a chat, we include suggested actions that are applicable to target users in our ICP. Sample documents and checklists also let users try the platform immediately, even without uploading their own files.
          </p>

          <div style={{maxHeight:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
            <ZoomableImg key={netxd_samples} src={netxd_samples} />
          </div>
          <p className='p' style={{textAlign: 'center', fontSize: '14px', opacity: '80%', marginTop: '10px'}}>
            Relevant sample files are available
          </p>

          <br/><br/><br/>

          {/* --------- SOLUTIONS 3 --------- */}

          <h3 className='h3'>3 - Building an <b style={{ color: this.accent_color }}>Adaptable</b> Interface</h3>
          
          <p className='p'>
          With XDAI's core use case being enterprise document review, we wanted to simplify this process as much as possible for users who might want to review 100s of documents at once. I designed XDAI to go beyond basic chat interaction and accommodate these high-volume workflows.
          </p>

          <p className='p'>
            <b>Anticipating user actions</b><br/>
            The AI should be able to anticipate future actions a user might want to accomplish. If a user reviews a set of documents, they should be prompted to create an agent from this request as a shortcut to future reviews of this type.
            <br/><br/>
            The UI should change in appearance to accommodate different types of actions. In the case of agent creation, the fields should appear with pre-generated data that the user can tweak to their liking
          </p>

          <video autoPlay loop muted playsInline width="100%" height="auto" style={{borderRadius:35}}>
             <source src={click_agent_flow} type="video/mp4" />
             Your browser does not support the video tag.
           </video>
          <p className='p' style={{textAlign: 'center', fontSize: '14px', opacity: '80%', marginTop: '10px'}}>
            Creating shortcuts from common workflows
          </p>

          <br/><br/>

          <p className='p'>
            <b>Not locked to chat</b><br/>
            While common in many other AI tools, enterprise data shouldn't be only accessible via the chat interface. Users should be able to create and access vital data in both the chat and in its own dedicated area of the interface while still aided by AI.
          </p>

          <p className='p'>
            <ImageScrollList>
              <img src={agent_creation} alt="Agent creation flowchart 1" />
              <img src={agent_editing} alt="Agent creation flowchart 2" />
              <img src={agent_running} alt="Agent creation flowchart 3" />
            </ImageScrollList>
          </p>
          <p className='p' style={{textAlign: 'center', fontSize: '14px', opacity: '80%', marginTop: '10px'}}>
            Initial flowcharts for the different methods of creating and editing an agent
          </p>
          <br/><br/>

          <p className='p'>
            The platform includes a dedicated agent panel where users can manage agents and review batch-processed documents, with AI available to assist at any stage.
          </p>

                      <video autoPlay loop muted playsInline width="100%" height="auto" style={{borderRadius:35}}>
            <source src={use_agents_tab} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p className='p' style={{textAlign: 'center', fontSize: '14px', opacity: '80%', marginTop: '10px'}}>
            The Agents tab
           </p>

          <br/><br/>

          <p className='p'>
            <b>Designed for enterprise</b><br/>
            The app's design emphasizes security with security-focused language throughout the interface.
          </p>

          <div style={{maxHeight:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
            <ZoomableImg key={data_privacy} src={data_privacy} />
          </div>

          <p className='p'>
            Early versions included two-way sync with Google Drive and Dropbox. To further protect user data and simplify batch operations, we integrated an internal directory where users can manage and share files across their organization while still supporting uploads from desktop or cloud storage.
          </p>

          <div style={{maxHeight:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
            <ZoomableImg key={directory_overview} src={directory_overview} />
          </div>
          <p className='p' style={{textAlign: 'center', fontSize: '14px', opacity: '80%', marginTop: '10px'}}>
            The Directory tab
          </p>

          <br/><br/>

          <p className='p'>
            <b>Unifying different types of data</b><br/>
            Users interact with chats, agents, and files in XDAI. A platform-wide search allows users to find data across all three while also offering filtering and sorting by type.
          </p>

          <div style={{maxHeight:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
            <ZoomableImg key={search_overview} src={search_overview} />
          </div>
          <p className='p' style={{textAlign: 'center', fontSize: '14px', opacity: '80%', marginTop: '10px'}}>
            Platform-wide search
          </p>

          <div className="divider"></div>

          {/* ---------- Impact ---------- */}
          <h2 className='h2'>Impact</h2>
          
          <p className='p'>
            The very first rough iterations of these designs were used to ship an alpha version of the product that alongside initial designs was used to pitch to investors, resulting in NETXD successfully securing funding.
          </p>

          <p className='p'>
            These prototyped designs also led to NETXD securing contracts with several Fortune 500 companies hoping to use enterprise-targeted features.
          </p>

          {/* ---------- Future Work ---------- */}
          <h2 className='h2'>Future Work</h2>

          <p className='p'>
            These designs are currently in the process of being implemented. You can try out the latest version of XDAI <a href="https://netxd.com/#/ai" target="_blank" style={{color: this.accent_color}}>here</a>.
          </p>

          <p className='p'>
            The designs are also continuing to evolve and change as NETXD receives user feedback and customer requests.
          </p>

          </PasswordComponent>
        </div>
        <Footer/>
      </div>
    )
  }
}

export default NETXDProjectPage; 